import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { renderLength } from "../../../../Utils/CommonUtils";
import { setPaginationTotalCount } from "../../../../slices/common/reducer";
import { Nav, NavItem } from "reactstrap";
import { Button } from "react-bootstrap";
import { PenIcon } from "../../../../assets/images/svg/svg";
import "./style.scss";

const SelectedTab = ({
  tabs,
  activeTab,
  changeActiveTab,
  apiCount,
  editMode,
  preventNavigationTabs,
  buttonEdit,
  label,
  onEditClick,
  checkAccessEdit,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (tabs && apiCount) {
      const moduleCode = tabs.find(
        (tab) => tab.value === activeTab
      )?.moduleCode;
      const count = apiCount[moduleCode] || 0;

      dispatch(setPaginationTotalCount(count));
    }
  }, [apiCount, activeTab]);

  return (
    <div>
      <Nav
        className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
        role="tablist"
      >
        {/* <NavLink> */}
        {tabs?.map((tab) => (
          <NavItem key={tab?.value}>
            <div
              className={`nav-link ${activeTab === tab?.value ? "active" : ""}`}
              onClick={() => {
                if (preventNavigationTabs?.includes(tab.value) && !editMode) {
                  return;
                }
                if (apiCount) {
                  dispatch(setPaginationTotalCount(apiCount[tab?.moduleCode]));
                }
                dispatch(changeActiveTab(tab?.value));
              }}
            >
              <div>
                {tab?.label}

                {apiCount && tab?.moduleCode && (
                  <div className="tab-quantity">
                    {renderLength(
                      activeTab === tab?.value ? "active" : "inactive",
                      apiCount[tab?.moduleCode] !== undefined
                        ? apiCount[tab?.moduleCode]
                        : "0"
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* </NavLink> */}
          </NavItem>
        ))}
        {/* {buttonEdit && (
          <div className="edit-container">
            <button
              className="btn btn-outline-primary edit-button"
              onClick={onEditClick}
            >
              <PenIcon className="pen-icon" />
              {label}
            </button>
          </div>
        )} */}
        {(checkAccessEdit === undefined || checkAccessEdit === true) &&
          buttonEdit && (
            <div className="edit-container">
              <button
                className="btn btn-outline-primary edit-button"
                onClick={onEditClick}
              >
                <PenIcon className="pen-icon" />
                {label}
              </button>
            </div>
          )}
      </Nav>
    </div>
  );
};

export default SelectedTab;
